import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchTrialTypes = async () => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/photos/get_trial_types/`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetTrialTypes = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["trial_types"],
    queryFn: () => fetchTrialTypes(),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export default useGetTrialTypes;
